<template>
  <div>
    <ShippingHeaderList :title="$t('cadastro-integracao-transportadora')" :total="total" :pagination="false" />
    <el-card>
      <ShippingHeaderSearch @fetch="search"  redirect="shipping.integration.edit" />
      <ShippingIntegrationTable :tableData="tableList" @remove="remove" />
    </el-card>
  </div>
</template>
<script>
import ShippingHeaderList from "./components/ShippingHeaderList.vue";
import ShippingHeaderSearch from "./components/ShippingHeaderSearch.vue";
import ShippingIntegrationTable from "./integration/ShippingIntegrationTable.vue";
import { ShippingIntegrationService } from "@/services/shipping/shipping.integration.services";

export default {
  name: "ShippingIntegrationPage",
  computed: {
    tableList() {
      return this.tableData.filter(x => 
        !this.filter.word || 
        x.service.toLowerCase().includes(this.filter.word.toLowerCase()) ||
        x.type.toLowerCase().includes(this.filter.word.toLowerCase()));
    }
  },
  methods: {
    search(filter) {
      this.filter.word = filter;
    },
    remove(index) {
      const vm = this;
      const data = vm.tableData[index];
      const loading = vm.$loading(vm.$options.loading);
      ShippingIntegrationService.delete(data.id)
        .then(() => {
          vm.tableData.splice(index, 1);
          this.$message({
            type: "error",
            message: "Registro removido com sucesso",
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ShippingIntegrationService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          this.$message({
              type: "error",
              message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      filter: {
        word: "",
      },
      total: 0,
      tableData: [],
    };
  },
  components: { ShippingHeaderList, ShippingIntegrationTable, ShippingHeaderSearch }
};
</script>

